import { MessageCircle } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";

export default function WhatsAppFloat() {
  const { settings } = useSettings();
  const phone = (settings.whatsapp_number || "15142389008").replace(/[^0-9]/g, "");
  const href = `https://wa.me/${phone}?text=${encodeURIComponent("Bonjour " + (settings.app_name || "Sama Écoute") + ", j'aimerais discuter.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Discuter sur WhatsApp"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 blur-xl group-hover:bg-[#25D366]/60 transition" />
      <span className="relative grid place-items-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.4)] hover:scale-105 transition-transform animate-float">
        <MessageCircle className="w-6 h-6" />
      </span>
    </a>
  );
}
